<template>
    <!-- 作品评级 -->
    <el-dialog :title="title" :visible.sync="gradeDialog" :width="width" :before-close="() => gradeDialog = false">
        <div class="p-grade-dialog-content">
            <el-form label-position="right" label-width="100px">
                <el-form-item label="作品ID">
                    {{ worksInfo.workId }}
                </el-form-item>
                <el-form-item label="作品名称">
                    {{ worksInfo.workName }}
                </el-form-item>
                <el-form-item label="推荐等级">
                    <el-radio-group v-model="grade">
                        <el-radio label="S">S 大神级</el-radio>
                        <el-radio label="A">A 专家级</el-radio>
                        <el-radio label="B">B 普通级</el-radio>
                        <el-radio label="C">C 业余级</el-radio>
                        <el-radio label="">不推荐</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer sel-footer">
            <el-button @click="gradeDialog = false">取消</el-button>
            <el-button type="primary" @click="setWorkRecommendLevel">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        worksInfo: {
            type: Object,
            default: () => {}
        },
        title: String,
        width: String
    },
    data() {
        return {
            gradeDialog: false,
            grade: ''
        }
    },
    methods: {
        async setWorkRecommendLevel() {
            let { openId } = this.worksInfo
            await this.api.setUserRecommendLevel({ openId, level: this.grade})

            this.$message.success('设置成功')
            this.gradeDialog = false
            this.$emit('success', this.grade)
        }
    },
    watch: {
        visible(val) {
            this.gradeDialog = val
        },
        gradeDialog(val) {
            if(!val) {
                this.$emit('close', val)
            }
        },
        worksInfo: {
            handler() {
                this.grade = this.worksInfo.recommendLevel || ''
            },
            deep: true
        }
    }
}
</script>

<style>

</style>
